export default "/images/vendor/flag-icon-css/flags/4x3/ee.svg?aca3624e7e3a31be0d4bb2cfdb7a4ada";